export default __webpack_public_path__ + "static/4_30-60200a06c7a6695302b486cfe23a5011.png";